import config from '../../../config';

export const fetchToken = ({
  clientId, clientSecret, code, state, tokenEndpoint, fetch = window.fetch,
}) => {
  const payload = {
    client_id: clientId,
    code,
    grant_type: 'authorization_code',
    code_verifier: state.encodedVerifier,
    redirect_uri: state.redirect_uri,
  };
  if (clientSecret) {
    payload.client_secret = clientSecret;
  }

  return fetch(tokenEndpoint, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    mode: 'cors',
    method: 'POST',
    body: new window.URLSearchParams(payload),
  })
    .then((r) => {
      if (!r.ok) {
        throw new Error(`Token response not ok, status is ${r.status}, check the react-u5auth configuration (wrong provider or token endpoint?)`);
      }
      return r.json();
    })
    .then((token) => {
      let { expires_in } = token;

      expires_in = parseInt(expires_in, 10);

      if (isNaN(expires_in) && !!config.clientTokenExpiration) {
        expires_in = config.clientTokenExpiration;
      } else if (!isNaN(expires_in) && !!config.clientTokenExpiration) {
        expires_in = Math.min(expires_in, config.clientTokenExpiration);
      }

      if (expires_in && !isNaN(expires_in) && Number.isFinite(expires_in)) {
        const slackSeconds = 10;
        token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - slackSeconds * 1000);
      }

      return token;
    })
    .catch((err) => {
      console.error('ERR (fetch)', err);
      throw err;
    });
};
